// extracted by mini-css-extract-plugin
export default {"cell":"Ticket_cell__LX+dT","flex":"Ticket_flex__ccOaa","block":"Ticket_block__h310z"};